import axios, { CancelTokenSource } from 'axios';
import buildQuery from 'odata-query';
import { handleApiError } from '../../common/util';
import { IOdataResult } from '../../models/odata.model';
import { ICompany } from '../../models/portal/company.model';
import axiosPortalInstance from './axiosPortalInstance';

export let getCompaniesByKeywordCancelTokenSource: CancelTokenSource;

export const getCompanyByDealerCode = async (dealerCode: string) => {
  try {
    const filter = { DealerCode: { eq: dealerCode } };
    const query = buildQuery({ filter });
    const url = `/api/company/v2/summary/${query}`;

    // Cancelation token
    getCompaniesByKeywordCancelTokenSource?.cancel(`CANCEL getCompaniesByKeyword`);
    getCompaniesByKeywordCancelTokenSource = axios.CancelToken.source();

    const response = await axiosPortalInstance.get<IOdataResult<ICompany>>(url, {
      cancelToken: getCompaniesByKeywordCancelTokenSource.token,
    });
    return response.data.items[0];
  } catch (err: any) {
    return handleApiError('getCompaniesByKeyword', err);
  }
};
